import { type FilterItem } from 'widgets/FilterEditor/model'

export const BroadcastStatusKeys = new Set([
  'broadcasts.status',
  'broadcasts_recurring_settings.status',
])

export const isBroadcastStatusWidget = (filterItem: FilterItem) =>
  BroadcastStatusKeys.has(filterItem.key)
